export var valuesTranslationCustomAttributeType = ["Text", "Select"];
/*

*/ 
//# sourceMappingURL=TranslationCustomAttributeType.js.map